/*
 * uploadWidgetTableController
 * */

class UploadWidgetTableController {
	constructor($log, $state, appConfig) {
		'ngInject';
		this.$log = $log;
		this.$state = $state;
		this.appConfig = appConfig;
		
	}

	$onInit() {
		this.$log = this.$log.getInstance('UploadWidgetTableController');
		this.$log.debug('loaded');
		this.calculatePercentage();
	}

	calculatePercentage() {
		let paperCount = 0;
		let digitalCount = 0;

		if (this.row.paperSubmissionCount > 0) {
			const totalCount = Number(this.row.paperSubmissionCount) + Number(this.row.digitalSubmissionCount);

			const percentPaperCount = (Number(this.row.paperSubmissionCount) / totalCount) * 100;

			const percentDigitalCount = (Number(this.row.digitalSubmissionCount) / totalCount) * 100;

			paperCount = `${this.row.paperSubmissionCount}	
			(${percentPaperCount === 100 || percentPaperCount === 0
				? percentPaperCount : percentPaperCount.toFixed(2)}%)`;

			digitalCount = `${this.row.digitalSubmissionCount}	
			(${percentDigitalCount === 100 || percentDigitalCount === 0
				? percentDigitalCount : percentDigitalCount.toFixed(2)}%)`;

			this.row.paperSubmissionCount = paperCount;
			this.row.digitalSubmissionCount = digitalCount;
		}
	}
}

export default UploadWidgetTableController;
